module.exports = __webpack_public_path__ + "img/home-duckrabbit_sm.1f7a85c2.png";